import React from 'react';
import GeoclientPopup from './GeoclientPopup';

const GeoclientWrapper = (props) => {
  return (
    <>
      {props.is_open ? (
        <div
          className="body-wrapper"
          style={{ position: 'relative', height: '100%' }}
        >
          <GeoclientPopup {...props} />
        </div>
      ) : null}
    </>
  );
};

export default GeoclientWrapper;
